import request from '@/utils/request'

export function updateVipCfg(data) {
  return request({
    url: 'api/v1/vip/updateVipCfg',
    method: 'post',
    data: data
  })
}

export function getVipCfgList(data) {
  return request({
    url: 'api/v1/vip/getList',
    method: 'post',
    data: data
  })
}

export function delVipCfgList(data) {
  return request({
    url: 'api/v1/vip/deleteVipCfg',
    method: 'delete',
    data: data
  })
}
